import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTankConcreteBase = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 120,
	height: 91,
	viewBox: "0 0 120.0 91.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 81,
			width: 120,
			height: 10,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 80,
			y: 3,
			width: 12,
			height: 8,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 10,
			y: 11,
			width: 100,
			height: 70,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 77.0 3.0 L 95.0 3.0 M 77.0 0.0 L 95.0 0.0 M 40.0 91.0 L 50.0 81.0 M 0.0 91.0 L 10.0 81.0 M 10.0 91.0 L 20.0 81.0 M 20.0 91.0 L 30.0 81.0 M 30.0 91.0 L 40.0 81.0 M 50.0 91.0 L 60.0 81.0 M 60.0 91.0 L 70.0 81.0 M 70.0 91.0 L 80.0 81.0 M 80.0 91.0 L 90.0 81.0 M 90.0 91.0 L 100.0 81.0 M 110.0 91.0 L 120.0 81.0 M 100.0 91.0 L 110.0 81.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgTankConcreteBase;
